import React, { useState } from 'react';

const JadwalUkt = () => {
    const [selectedJalur, setSelectedJalur] = useState(
        "Mandiri ICP"
    );

    const jadwalJalur = {

        "Mandiri ICP": [
            ["Pengisian Data UKT", "12 Agustus - 20 Agustus 2026"],
            ["Pengumuman UKT", "21 Agustus 2026"],
            ["Pembayaran UKT", "12 Agustus - 19 Agustus 2026"],
            ["Lapor Diri & Registrasi", "12 Agustus - 20 Agustus 2026"],
        ],

        "Mandiri di Kediaman dan Disabilitas": [
            ["Pengisian Data UKT", "31 Juli - 4 Agustus 2026"],
            ["Pengumuman UKT", "5 Agustus 2026"],
            ["Pembayaran UKT", "5 Agustus - 11 Agustus 2026"],
            ["Lapor Diri & Registrasi", "5 Agustus - 12 Agustus 2026"],
        ],

        "Mandiri di Kampus": [
            ["Pengisian Data UKT", "15 - 18 Juli 2026"],
            ["Pengumuman UKT", "19 Juli 2026"],
            ["Pembayaran UKT", "19 Juli - 24 Juli 2026"],
            ["Lapor Diri & Registrasi", "19 Juli - 25 Juli 2026"],
        ],

        "Mandiri Nilai UTBK": [
            ["Pengisian Data UKT", "26 - 30 Juni 2026"],
            ["Pengumuman UKT", "2 Juli 2026"],
            ["Pembayaran UKT", "2 Juli - 10 Juli 2026"],
            ["Lapor Diri & Registrasi", "2 Juli - 10 Juli 2026"],
        ],

        "Mandiri Rapor dan Prestasi": [
            ["Pengisian Data UKT", "17 - 21 Juni 2026"],
            ["Pengumuman UKT", "23 Juni 2026"],
            ["Pembayaran UKT", "23 Juni - 22 Juli 2026"],
            ["Lapor Diri & Registrasi", "23 Juni - 22 Juli 2026"],
        ],
    };


    return (
        <div>

            <div style={{ marginBottom: "15px" }}>
                <label>
                    Pilih Jalur :
                </label>

                <select
                    value={selectedJalur}
                    onChange={(e) => setSelectedJalur(e.target.value)}
                    style={{
                        marginLeft: "10px",
                        padding: "8px"
                    }}
                >
                    {Object.keys(jadwalJalur).map((jalur) => (
                        <option key={jalur} value={jalur}>
                            {jalur}
                        </option>
                    ))}
                </select>
            </div>


            <div
                style={{
                    width: '100%',
                    overflowX: 'auto',
                    WebkitOverflowScrolling: 'touch'
                }}
            >
                <table
                    className="premium-table-modern"
                    style={{ minWidth: '600px' }}
                >
                    <thead>
                        <tr>
                            <th width="40%">Kegiatan</th>
                            <th width="60%">
                                Jadwal {selectedJalur}
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {jadwalJalur[selectedJalur].map((item, index) => (
                            <tr key={index}>
                                <td>{item[0]}</td>
                                <td>{item[1]}</td>
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>

        </div>
    );
};

export default JadwalUkt;